import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_06ac614a from 'nuxt_plugin_plugin_06ac614a' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_e4551238 from 'nuxt_plugin_plugin_e4551238' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_toastplugin6b866e18_3f56117c from 'nuxt_plugin_toastplugin6b866e18_3f56117c' // Source: ./toast.plugin.6b866e18.js (mode: 'all')
import nuxt_plugin_editorplugin44a66126_28a5636a from 'nuxt_plugin_editorplugin44a66126_28a5636a' // Source: ./editor.plugin.44a66126.js (mode: 'all')
import nuxt_plugin_radiobuttonplugin78a7265e_2a8b8db1 from 'nuxt_plugin_radiobuttonplugin78a7265e_2a8b8db1' // Source: ./radiobutton.plugin.78a7265e.js (mode: 'all')
import nuxt_plugin_messageplugin369e2e10_eb8aaffe from 'nuxt_plugin_messageplugin369e2e10_eb8aaffe' // Source: ./message.plugin.369e2e10.js (mode: 'all')
import nuxt_plugin_textareaplugina821dc9a_190d3f58 from 'nuxt_plugin_textareaplugina821dc9a_190d3f58' // Source: ./textarea.plugin.a821dc9a.js (mode: 'all')
import nuxt_plugin_dialogplugin3b836741_7ad95b9b from 'nuxt_plugin_dialogplugin3b836741_7ad95b9b' // Source: ./dialog.plugin.3b836741.js (mode: 'all')
import nuxt_plugin_passwordplugin55850fd4_ea5e1226 from 'nuxt_plugin_passwordplugin55850fd4_ea5e1226' // Source: ./password.plugin.55850fd4.js (mode: 'all')
import nuxt_plugin_checkboxplugin72cd1efc_5c6d4fca from 'nuxt_plugin_checkboxplugin72cd1efc_5c6d4fca' // Source: ./checkbox.plugin.72cd1efc.js (mode: 'all')
import nuxt_plugin_buttonplugin0f1096aa_8b5122b2 from 'nuxt_plugin_buttonplugin0f1096aa_8b5122b2' // Source: ./button.plugin.0f1096aa.js (mode: 'all')
import nuxt_plugin_multiselectplugin795cf634_0f7aaf73 from 'nuxt_plugin_multiselectplugin795cf634_0f7aaf73' // Source: ./multiselect.plugin.795cf634.js (mode: 'all')
import nuxt_plugin_dropdownplugin1a0dbdca_2a224796 from 'nuxt_plugin_dropdownplugin1a0dbdca_2a224796' // Source: ./dropdown.plugin.1a0dbdca.js (mode: 'all')
import nuxt_plugin_columnplugine1d2f862_593d410d from 'nuxt_plugin_columnplugine1d2f862_593d410d' // Source: ./column.plugin.e1d2f862.js (mode: 'all')
import nuxt_plugin_datatableplugin05f48815_424fbf4e from 'nuxt_plugin_datatableplugin05f48815_424fbf4e' // Source: ./datatable.plugin.05f48815.js (mode: 'all')
import nuxt_plugin_inputtextplugin07280de8_7bbca4fe from 'nuxt_plugin_inputtextplugin07280de8_7bbca4fe' // Source: ./inputtext.plugin.07280de8.js (mode: 'all')
import nuxt_plugin_configplugin281d3cbb_0ac96420 from 'nuxt_plugin_configplugin281d3cbb_0ac96420' // Source: ./config.plugin.281d3cbb.js (mode: 'all')
import nuxt_plugin_axios_02aeab60 from 'nuxt_plugin_axios_02aeab60' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_amplifyconfig_4d66aab6 from 'nuxt_plugin_amplifyconfig_4d66aab6' // Source: ../plugins/amplify-config.js (mode: 'all')
import nuxt_plugin_amplifycomponents_3b5021e2 from 'nuxt_plugin_amplifycomponents_3b5021e2' // Source: ../plugins/amplify-components.js (mode: 'all')
import nuxt_plugin_axios_673c6d87 from 'nuxt_plugin_axios_673c6d87' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_appui_4329c131 from 'nuxt_plugin_appui_4329c131' // Source: ../plugins/app-ui.js (mode: 'all')
import nuxt_plugin_filter_13ed0f0e from 'nuxt_plugin_filter_13ed0f0e' // Source: ../plugins/filter.js (mode: 'all')
import nuxt_plugin_vuexpersist_13f465a2 from 'nuxt_plugin_vuexpersist_13f465a2' // Source: ../plugins/vuex-persist (mode: 'client')
import nuxt_plugin_eventbus_2faefc80 from 'nuxt_plugin_eventbus_2faefc80' // Source: ../plugins/event-bus.js (mode: 'all')
import nuxt_plugin_appservices_65c090f7 from 'nuxt_plugin_appservices_65c090f7' // Source: ../plugins/app-services.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Service Counter","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_06ac614a === 'function') {
    await nuxt_plugin_plugin_06ac614a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_e4551238 === 'function') {
    await nuxt_plugin_plugin_e4551238(app.context, inject)
  }

  if (typeof nuxt_plugin_toastplugin6b866e18_3f56117c === 'function') {
    await nuxt_plugin_toastplugin6b866e18_3f56117c(app.context, inject)
  }

  if (typeof nuxt_plugin_editorplugin44a66126_28a5636a === 'function') {
    await nuxt_plugin_editorplugin44a66126_28a5636a(app.context, inject)
  }

  if (typeof nuxt_plugin_radiobuttonplugin78a7265e_2a8b8db1 === 'function') {
    await nuxt_plugin_radiobuttonplugin78a7265e_2a8b8db1(app.context, inject)
  }

  if (typeof nuxt_plugin_messageplugin369e2e10_eb8aaffe === 'function') {
    await nuxt_plugin_messageplugin369e2e10_eb8aaffe(app.context, inject)
  }

  if (typeof nuxt_plugin_textareaplugina821dc9a_190d3f58 === 'function') {
    await nuxt_plugin_textareaplugina821dc9a_190d3f58(app.context, inject)
  }

  if (typeof nuxt_plugin_dialogplugin3b836741_7ad95b9b === 'function') {
    await nuxt_plugin_dialogplugin3b836741_7ad95b9b(app.context, inject)
  }

  if (typeof nuxt_plugin_passwordplugin55850fd4_ea5e1226 === 'function') {
    await nuxt_plugin_passwordplugin55850fd4_ea5e1226(app.context, inject)
  }

  if (typeof nuxt_plugin_checkboxplugin72cd1efc_5c6d4fca === 'function') {
    await nuxt_plugin_checkboxplugin72cd1efc_5c6d4fca(app.context, inject)
  }

  if (typeof nuxt_plugin_buttonplugin0f1096aa_8b5122b2 === 'function') {
    await nuxt_plugin_buttonplugin0f1096aa_8b5122b2(app.context, inject)
  }

  if (typeof nuxt_plugin_multiselectplugin795cf634_0f7aaf73 === 'function') {
    await nuxt_plugin_multiselectplugin795cf634_0f7aaf73(app.context, inject)
  }

  if (typeof nuxt_plugin_dropdownplugin1a0dbdca_2a224796 === 'function') {
    await nuxt_plugin_dropdownplugin1a0dbdca_2a224796(app.context, inject)
  }

  if (typeof nuxt_plugin_columnplugine1d2f862_593d410d === 'function') {
    await nuxt_plugin_columnplugine1d2f862_593d410d(app.context, inject)
  }

  if (typeof nuxt_plugin_datatableplugin05f48815_424fbf4e === 'function') {
    await nuxt_plugin_datatableplugin05f48815_424fbf4e(app.context, inject)
  }

  if (typeof nuxt_plugin_inputtextplugin07280de8_7bbca4fe === 'function') {
    await nuxt_plugin_inputtextplugin07280de8_7bbca4fe(app.context, inject)
  }

  if (typeof nuxt_plugin_configplugin281d3cbb_0ac96420 === 'function') {
    await nuxt_plugin_configplugin281d3cbb_0ac96420(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_02aeab60 === 'function') {
    await nuxt_plugin_axios_02aeab60(app.context, inject)
  }

  if (typeof nuxt_plugin_amplifyconfig_4d66aab6 === 'function') {
    await nuxt_plugin_amplifyconfig_4d66aab6(app.context, inject)
  }

  if (typeof nuxt_plugin_amplifycomponents_3b5021e2 === 'function') {
    await nuxt_plugin_amplifycomponents_3b5021e2(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_673c6d87 === 'function') {
    await nuxt_plugin_axios_673c6d87(app.context, inject)
  }

  if (typeof nuxt_plugin_appui_4329c131 === 'function') {
    await nuxt_plugin_appui_4329c131(app.context, inject)
  }

  if (typeof nuxt_plugin_filter_13ed0f0e === 'function') {
    await nuxt_plugin_filter_13ed0f0e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersist_13f465a2 === 'function') {
    await nuxt_plugin_vuexpersist_13f465a2(app.context, inject)
  }

  if (typeof nuxt_plugin_eventbus_2faefc80 === 'function') {
    await nuxt_plugin_eventbus_2faefc80(app.context, inject)
  }

  if (typeof nuxt_plugin_appservices_65c090f7 === 'function') {
    await nuxt_plugin_appservices_65c090f7(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
